module.exports = __webpack_public_path__ + "img/a38.ca947585.svg";